
import React from 'react';
import { motion } from 'framer-motion';
import LazyImage from '@/components/ui/LazyImage';
import Section from './Section';
import { getStaticMediaUrl, STATIC_MEDIA_FILES } from '@/config/staticMedia';

interface LifestyleSectionProps {
  fadeInUp: any;
  staggerContainer: any;
}

const LifestyleSection: React.FC<LifestyleSectionProps> = ({
  fadeInUp,
  staggerContainer
}) => {
  return (
    <Section
      variants={staggerContainer}
      className="justify-center items-center relative overflow-hidden"
    >
      {/* Gradiente elegante com vermelho/rosa/roxo */}
      <div className="absolute inset-0 bg-gradient-to-tr from-luxury-purple/8 via-transparent to-luxury-red/8"></div>
      
      <div className="max-w-6xl mx-auto text-center relative z-10">
        <motion.div variants={fadeInUp} className="mb-16">
          <div className="aspect-[16/9] md:aspect-[21/9] rounded-2xl border border-white/20 overflow-hidden mb-16 shadow-2xl shadow-luxury-mediumPink/10 relative">
            <div className="absolute inset-0 bg-gradient-to-t from-luxury-purple/30 via-transparent to-luxury-darkPink/20 z-10"></div>
            <LazyImage
              src={getStaticMediaUrl(STATIC_MEDIA_FILES.DATE_3)}
              alt="Experiência de Luxo Interlaced"
              className="w-full h-full object-cover"
              fallbackClassName="w-full h-full"
            />
          </div>
        </motion.div>

        <motion.div variants={fadeInUp}>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-12">
            Mais do que um aplicativo, uma porta de entrada para outro padrão de vida
            <br />
            <span className="text-luxury-mediumPink/90">
              exclusivo e sofisticado
            </span>
            <br />
            <span className="bg-gradient-to-r from-luxury-red via-luxury-mediumPink to-luxury-purple bg-clip-text text-transparent">
              que poucos conhecem
            </span>
          </h2>
          <p className="text-xl text-white/80 max-w-4xl mx-auto leading-relaxed mb-8">
            Para quem tem ambição, classe e sabe exatamente onde quer chegar, a Interlaced não oferece encontros.
          </p>
          <p className="text-xl text-luxury-mediumPink/90 max-w-4xl mx-auto leading-relaxed mb-8 font-medium">
            Oferece acesso.
          </p>
          <p className="text-lg text-white/70 max-w-4xl mx-auto leading-relaxed">
            Um ambiente onde jovens seletos encontram conexões que abrem possibilidades, aceleram trajetórias e respeitam o silêncio de quem sabe viver bem sem exposição, sem ruído, sem explicações.
          </p>
        </motion.div>
      </div>
    </Section>
  );
};

export default LifestyleSection;
